import { render, staticRenderFns } from "./XLS.vue?vue&type=template&id=2e88c10f&"
import script from "./XLS.vue?vue&type=script&lang=js&"
export * from "./XLS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports